import { carouselItems } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              重磅推荐
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500">
              编辑精选的优质专题内容，不容错过的精彩合集
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {carouselItems.map((item) => (
              <article
                key={item.id}
                className="group flex flex-col sm:flex-row gap-5 p-5 rounded-2xl bg-background-100 border border-background-200/60 cursor-pointer hover:border-primary-200 transition-all"
              >
                <div className="w-full sm:w-48 md:w-56 flex-shrink-0 aspect-[16/10] sm:aspect-auto sm:h-36 rounded-xl overflow-hidden bg-background-200">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="flex flex-col justify-between flex-1 min-w-0">
                  <div>
                    <span className="inline-block text-xs font-medium px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 mb-2">
                      {item.tag}
                    </span>
                    <h3 className="text-base md:text-lg font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors leading-snug">
                      {item.title}
                    </h3>
                    <p className="mt-2 text-sm text-foreground-500 leading-relaxed line-clamp-3">
                      {item.desc}
                    </p>
                  </div>
                  <span className="mt-3 text-xs text-primary-500 font-medium flex items-center gap-1">
                    查看详情 <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}